import React from 'react';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import highchartsMore from 'highcharts/highcharts-more.js';
import solidGauge from 'highcharts/modules/solid-gauge.js';
highchartsMore(Highcharts);
solidGauge(Highcharts);

export function Gauge({ data, real, objetivoId, excluirSinMonitoreo }) {
  const chartRef = React.useRef(null);
  const containerRef = React.useRef(null);

  React.useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const resizeObserver = new ResizeObserver(() => {
      if (chartRef.current) {
        chartRef.current.chart.reflow();
      }
    });

    resizeObserver.observe(container);

    return () => {
      resizeObserver.unobserve(container);
    };
  }, []);

  function processData() {
    const objectives = sessionStorage.getItem('listaObjetivosOnline');
    let uptime = data.uptime || 0;
    if (real) {
      uptime =
        parseFloat(data.uptime) +
        parseFloat(data.parcial) +
        parseFloat(data['evento_cliente']) +
        parseFloat(data['marcado_atentus']);
      if (!excluirSinMonitoreo) {
        uptime += parseFloat(data['no monitoreo']);
      }
      uptime = parseFloat(uptime.toFixed(2));
    }

    let sla_disponibilidad_error = 0;
    let sla_disponibilidad_ok = 90;
    if (objectives) {
      const objList = JSON.parse(objectives);
      const currentObj = objList.find(
        (obj) => parseInt(obj.objetivo_id) === parseInt(objetivoId)
      );
      if (currentObj) {
        sla_disponibilidad_error = parseFloat(
          currentObj.sla_disponibilidad_error
        );
        sla_disponibilidad_ok = parseFloat(currentObj.sla_disponibilidad_ok);
      }
    }
    return {
      chart: {
        type: 'solidgauge',
        plotBackgroundColor: null,
        plotBackgroundImage: null,
        plotBorderWidth: 0,
        plotShadow: false,
        height: 300,
      },
      title: null,
      subtitle: null,
      xAxis: {
        categories: ['nada'],
        labels: {
          rotation: -45,
          enabled: true,
        },
        title: {
          text: null,
        },
        gridLineWidth: 0,
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        solidgauge: {
          dataLabels: {
            y: 5,
            borderWidth: 0,
            useHTML: true,
            color: '#66788A',
          },
        },
      },
      pane: {
        startAngle: -90,
        endAngle: 90,
        background: {
          innerRadius: '60%',
          outerRadius: '100%',
          shape: 'arc',
        },
        center: ['50%', '75%'],
        size: '120%'
      },
      yAxis: [
        {
          labels: {
            enabled: false,
            rotation: 'auto',
            style: {
              color: '#FFF',
            },
          },
          min: 0,
          max: 100,
          stops: [
            [0, '#C2272D'], // red
            [sla_disponibilidad_error / 100, '#C2272D'], // red
            [sla_disponibilidad_error / 100 + 0.0001, '#FFC600'], // yellow
            [sla_disponibilidad_ok / 100 - 0.0001, '#FFC600'], // yellow
            [sla_disponibilidad_ok / 100, '#41B900'], // green
            [1, '#41B900'], // green
          ],
        },
        {
          linkedTo: 0,
          lineWidth: 0,
          minorTickLength: 0,
          tickPositions: [sla_disponibilidad_error],
          tickLength: 60,
          tickColor: '#DF5353',
          tickWidth: 3,
          zIndex: 6,
        },
        {
          linkedTo: 0,
          lineWidth: 0,
          minorTickLength: 0,
          tickPositions: [sla_disponibilidad_ok],
          tickLength: 60,
          tickColor: '#55BF3B',
          tickWidth: 3,
          zIndex: 6,
        },
      ],
      series: [
        {
          name: 'Uptime',
          color: '#41B900',
          data: [uptime > 100 ? 100.0 : uptime],
          dataLabels: {
            format:
              '<div style="text-align:bottom">' +
              '<span style="font-size:25px">{y}</span>' +
              '<span style="font-size:12px;opacity:0.4">%</span>' +
              '</div>',
            style: {
              color: '#66788A',
            },
          },
        },
        {
          name: 'Uptime',
          type: 'gauge',
          data: [uptime],
        },
      ],
    };
  }

  const chartOptions = processData();

  return (
    <div ref={containerRef}>
      <HighchartsReact
        ref={chartRef}
        highcharts={Highcharts}
        options={chartOptions}
        containerProps={{ style: { height: '100%', width: '100%' } }}
      />
    </div>
  );
}
